// 用来存放后端所有验证状态
var code = {
    // 以下的参数都用在前端SDK中的错误码
    1000000: {
        "errcode": 13001,
        "errmsg": "初始化失败，请稍候重试"
    },
    // 账号 密码 验证码 错误
    //验证登录账号为空
    1010000: {
        "errcode": 11008,
        "errmsg": "请输入登录帐号"
    },
    // 验证手机验证码错误
    1010001: {
        "errcode": 11007,
        "errmsg": "验证码错误"
    },
    // 验证密码登录密码为空
    1010002: {
        "errcode": 11011,
        "errmsg": "请输入密码"
    },
    // 验证更换手机号TAG标识为空
    1010003: {
        "errcode": 11702,
        "errmsg": "更换手机号TAG不能为空"
    },
    // 手机号验证
    1010004: {
        "errcode": 11003,
        "errmsg": "手机号不合法"
    },
    // 验证类型不能为空
    1010005: {
        "errcode": 11801,
        "errmsg": "验证类型不能为空"
    },
    // 手机号不能为空验证
    1010006: {
        "errcode": 11002,
        "errmsg": "请输入手机号"
    },
    // 验证手机号合法性
    1010007: {
        "errcode": 11003,
        "errmsg": "手机号格式有误"
    },
    // 手机验证码为空验证
    1010008: {
        "errcode": 11006,
        "errmsg": "请输入验证码"
    },
    // 忘记密码验证旧手机验证码为空
    1010009: {
        "errcode": 11803,
        "errmsg": "请输入验证码"
    },
    // 账号安全验证手机号合法性
    1010011: {
        "errcode": 11508,
        "errmsg": "手机号格式有误"
    },
    // 账号安全验证手机号合为空
    1010012: {
        "errcode": 11507,
        "errmsg": "请输入手机号"
    },
    // 账号安全验证码合法性
    1010013: {
        "errcode": 11804,
        "errmsg": "验证码错误"
    },
    // 账号安全验证密码为空
    1010014: {
        "errcode": 11601,
        "errmsg": "请输入正确的密码信息"
    },
    // 账号安全验证密码合法性
    1010015: {
        "errcode": 11602,
        "errmsg": "请遵循密码规则设置新密码"
    },
    // 更换手机号验证码合法性验证
    1010016: {
        "errcode": 11703,
        "errmsg": "验证码错误"
    },
    // 邮箱不能为空
    1010017: {
        "errcode": 11526,
        "errmsg": "请输入邮箱"
    },
    // 邮箱格式错误
    1010018: {
        "errcode": 11527,
        "errmsg": "邮箱格式错误"
    },
    // 嵌入式id不能为空
    1010019: {
        "errcode": 11528,
        "errmsg": "验证码容器id不能为空"
    },
    // 个人信息相关code
    // 验证通行证的合法性
    1020000: {
        "errcode": 12005,
        "errmsg": "通行证格式有误"
    },
    // 验证昵称合法性
    1020001: {
        "errcode": 12011,
        "errmsg": "昵称格式有误"
    },
    // 验证真实姓名合法性
    1020002: {
        "errcode": 12008,
        "errmsg": "真实姓名格式有误"
    },
    // 验证英文合法性
    1020003: {
        "errcode": 12007,
        "errmsg": "英文名格式有误"
    },
    // 验证生日信息合法性
    1020004: {
        "errcode": 12018,
        "errmsg": "生日信息格式有误"
    },
    // 验证在读年级合法性
    1020005: {
        "errcode": 12014,
        "errmsg": "年级不合法"
    },
    1020006: {
        "errcode": 12202,
        "errmsg": "图片格式不支持，请重新选择后上传"
    },
    // 地址信息相关code
    1030000: {
        "errcode": 12519,
        "errmsg": "地址id不合法"
    },
    // 验证收货人信息合法性
    1030001: {
        "errcode": 12503,
        "errmsg": "收货人姓名格式有误"
    },
    1030002: {
        "errcode": 12509,
        "errmsg": "邮编不合法"
    },
    // 验证收货地址详细信息合法性
    1030003: {
        "errcode": 12517,
        "errmsg": "详细地址格式有误"
    },
    // 验证备注信息长度合法性
    1030004: {
        "errcode": 12521,
        "errmsg": "备注信息格式有误"
    },
    // 验证收货人姓名为空
    1030005: {
        "errcode": 12502,
        "errmsg": "请输入收货人姓名"
    },
    // 验证收货人手机号为空
    1030006: {
        "errcode": 12506,
        "errmsg": "请输入联系电话"
    },
    // 验证收货人手机号合法性
    1030007: {
        "errcode": 12507,
        "errmsg": "联系电话格式有误"
    },
    // 验证收货地址详细信息为空
    1030008: {
        "errcode": 12516,
        "errmsg": "请输入详细地址"
    },
    // 地区格式错误
    // 验证省份信息合法性
    1040000: {
        "errcode": 12511,
        "errmsg": "省份信息格式有误"
    },
    // 验证城市信息合法性
    1040001: {
        "errcode": 12513,
        "errmsg": "城市信息格式有误"
    },
    // 验证区县信息合法性
    1040002: {
        "errcode": 12515,
        "errmsg": "区县信息格式有误"
    },
    // 验证省份信息为空
    1040003: {
        "errcode": 12510,
        "errmsg": "请选择省份信息"
    },
    // 验证城市信息为空
    1040004: {
        "errcode": 12512,
        "errmsg": "请选择城市信息"
    },
    // 验证区县信息为空
    1040005: {
        "errcode": 12514,
        "errmsg": "请选择区县信息"
    },
    // 验证头像tai_id为空
    1040006: {
        "errcode": 10003,
        "errmsg": "参数请求异常，请稍候重试"
    },
    // 验证aes加密资源文件是否加载成功
    1000002: {
        "errcode": 13002,
        "errmsg": "aes加密资源文件crypto初始化失败，请稍候重试"
    },
    // 机构相关错误信息
    // 非机构调用机构方法
    1050001: {
        "errcode": '13003',
        "errmsg": "非机构调用机构方法,请配置是否为机构调用"
    },
    // 机构国家码为空
    1050002: {
        "errcode": '13004',
        "errmsg": "请输入手机号国家码"
    },
    // 机构手机号为空
    1050003: {
        "errcode": '13005',
      "errmsg": "请输入机构手机号"
    },
    // 机构名称不合法
    1050004: {
        "errcode": '13006',
        "errmsg": "机构名称格式有误"
    },
  // 头像信息不为空
  1050005: {
    "errcode": '10003',
    "errmsg": "头像信息不为空或者删除上传头像参数"
  },
};
for (let key in code) {
    code[key].errsource = 'front'
}
module.exports = code;



// WEBPACK FOOTER //
// ./src/code.js